//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import parse from 'date-fns/parse'
import format from 'date-fns/format'

export default {
  props: {
    count: {
      type: Number,
      default: 4
    },
    location: {
      type: String,
      default: 'default'
    },
    city: {
      type: String,
      default: null
    },
    keyword: {
      type: String,
      default: null
    },
    page: {
      type: String,
      default: 'home',
    },
    post_id: {
      type: Number,
      default: 43,
    },
    inclusions: {
      type: String,
      default: ''
    }
  },

  computed: {
   
  },
  watch: {

  },
  components: {

  },
  filters: {

  },
  data() {
    return { 
      
      loading: true,
      events: [],
      included: false,
      leftEvents: [],
      rightEvents: [],
      containerClass: 'featured-events--block',
      activeEvent: null,
      eventApiKey: eventApiKey
     
    }
  },
  mounted() {

    let self = this;

    let data = {
      action: 'featured_events',
      page: this.page,
      post_id: this.post_id
    };


      if (this.inclusions) {
        this.included = this.inclusions;
      }

      this.getEvents();
 

  },
  methods: {
    setActiveEvent(event) {
      this.activeEvent = event;
    },
    checkTarget(e, href) {
      if (this.page == 'events') {
        e.preventDefault(0);
        console.log('this is working', href);
        window.location.href = href;
        window.location.reload();
      }
    },
    getUpload(event) {
      if (event.thumbnail && event.thumbnail.length > 0) {
        return event.thumbnail.replace('_t.', '_o.');
      } else {
        return false;
      }
    },
    printDate(dt, ps, fm) {
      return format( parse(dt, ps, new Date()), fm );
    },
    getEvents() {

   
      let url = 'https://api.everwondr.com/'+this.eventApiKey+'/events?limit='+this.count;

      if (this.included) {
        url = url + '&include='+this.included;
      }
      if (featuredEvents.length) {
        url = url + '&include='+featuredEvents.join(',');
      }
      if (this.city) {
        url = url + '&keyword='+this.city;
      } else if (this.keyword) {
        url = url + '&keyword='+this.keyword;
      }

      axios.get(url)
      .then((response) => {
        this.events = response.data.results;
        this.activeEvent = this.events[0];
      })
      .catch(function (error) {

      });

    }
  }
}




// WEBPACK FOOTER //
// ./scripts/components/UpcomingEvents.vue